import { Directive, HostListener, SecurityContext } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
    selector: '[sanitizeInputForm]',
    standalone: false
})
export class SanitizeInputFormDirective {

  constructor(private readonly ngControl: NgControl, private readonly sanitizer: DomSanitizer) {
    }

    get ctrl() {
        return this.ngControl.control;
    }

    /** 
    * Sanitizing user entered text using DOMSanitizer.
    *
    * The special characters & " < > are converted to the following encoding while sanitization is done.
    * 
    * & - &amp;
    * " - &quot; or &#34; 
    * < - &lt;
    * > - &gt;
    * 
    * 
    * So we are replacing them with empty string using a regex if they are present in the string even when pasted.
    * 
    * If we find a future need to allow any of these characters to be included, we can customize accordingly.
    */
    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        const value = input.value;
        let sanitized = this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
        // regex to replace encoded values and any safe html tags
        sanitized = sanitized.replace(/<[^>]*>|&[^;]+;/g, '');
        if (value !== sanitized) {
            if (this.ctrl) {
                this.ctrl?.setValue(sanitized, { emitEvent: false });
            }
        }
    }

}
